module.exports = __webpack_public_path__ + "img/ophthalmic_main.0e1b4465.png";